import { render, staticRenderFns } from "./workspace-library-electronic-archive-category-view.vue?vue&type=template&id=d92f0182"
import script from "./workspace-library-electronic-archive-category-view.vue?vue&type=script&lang=js"
export * from "./workspace-library-electronic-archive-category-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports